// extracted by mini-css-extract-plugin
export default {"cookies":"cookie-popup_cookies__JdQW7"};